import { useQuery } from 'react-query';

import { OrganisationUsage } from '../../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

// Credit usage for an org, optionally scoped to a date range and/or a single matter.
// Omitting the filters returns the default billing-period view.
export const useFetchOrgUsageData = (
  enabled: boolean,
  organisationId: string,
  filters: { startDate?: Date; endDate?: Date; matterId?: string } = {},
) => {
  const { fetchConfigGET } = useGetFetchConfig();
  const { startDate, endDate, matterId } = filters;

  return useQuery<OrganisationUsage>(
    [QueryEntity.OrgUsageData, { organisationId, startDate, endDate, matterId }],
    () => {
      const url = new URL(`${APIBaseChronos}/api/usage/org-usage`);
      // Only platform usage operators viewing another org pass organisationId; otherwise the backend
      // scopes to the requester's own org.
      url.searchParams.append('organisationId', organisationId);
      if (startDate && endDate) {
        url.searchParams.append('startDate', startDate.toISOString());
        url.searchParams.append('endDate', endDate.toISOString());
      }
      if (matterId) {
        url.searchParams.append('matterId', matterId);
      }

      return fetch(url.toString(), {
        ...fetchConfigGET,
        method: FetchMethod.GET,
      })
        .then((res) => res.json())
        .catch((err) => {
          console.error(err);
        });
    },
    {
      enabled,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  );
};
